// Provider configuration
export interface PolicyAdminProviderConfig {
  name: string;
  apiKey: string;
}

// Application
export interface Application {
  id: number;
  number: string;
  type: string;
  effective_date: string;
  expiration_date: string;
  program: string;
  named_insured: string;
  total_locations_limit?: number;
  internal_underwriting_notes: string;
  underwriter: string;
}

// Documents
export enum ApplicationDocumentType {
  HAZARD_HUB = "Hazard Hub",
  OTHER_DOCUMENT = "Refer",
}

export interface ApplicationDocument {
  name: string;
  url: string;
  type: ApplicationDocumentType;
  created: string;
}
